module.exports = __webpack_public_path__ + "img/Bayon.07624bf9.png";